import React, { useEffect, useState } from "react";
import Web3 from 'web3'
import { Link } from "react-router-dom";
import { useWeb3React } from '@web3-react/core'
import ABI from './abi.json'
import Logo from "../../Pyragon/PyraGon.png";
import BackGround from "../../Pyragon/1.png";
import "./about.css";

const About = () => {
  const { chainId, account } = useWeb3React()
  console.log(chainId, account)
  const web3 = new Web3(Web3.givenProvider)
  const contract = new web3.eth.Contract(ABI, '0x5F6AbBd0B81f30E0718FA1cc2e189C0a57F6Bb2C')

  const [balance, setBalance] = useState()
  const [dividend, setDividend] = useState()
  // const [account, setAccaunt] = useState()

  useEffect(() => {
    account && 
      contract.methods.decimals().call().then(dec => {
        contract.methods.balanceOf(account).call().then(val => setBalance((val / 10 ** dec).toFixed(4)))
        contract.methods.withdrawableDividendOf(account).call().then(val => setDividend((val / 10 ** 18).toFixed(4)))
      })
    // account && contract.methods.balanceOf(account).call().then(val => setBalance(val))
  }, [account, contract.methods])

  const claim = () => {
      // alert(`network ${chainId}`)
      console.log('network', chainId)
      if (chainId === 97 || chainId === 56) {
          console.log(account)
          contract.methods
            .withdrawDividends()
            .send({ from: account })
            .on('transactionHash', (hash) => console.log('hash transaction', hash))
            .on('receipt', (receipt) => console.log('receipt transaction', receipt))
            .on('error', (err) => console.log(err))
      } else {
        alert('Please change network on BSC')
      }
  }

  return (
    <div className="popup-main-container">
      {/* <img class="demo-bg" src={BackGround} alt="" /> */}
      <div className="popup-section-1">
     <Link to="/">
        <img
          alt="img"
          src={Logo}
          style={{
            width: "50px",
            height: "45px",
            padding: "3px",
            marginLeft: "20px",
          }}
          />
          </Link>
        <div className="popup-section-1-2">
          <div id="popup-section-1-2-1">
            {" "}
            <h3>{balance ? balance : 0} PYRA</h3>{" "}
          </div>
          <div id="popup-section-1-2-2">
            {" "}
            <h3>
              {!account && 'Connect Wallet'}
              <span className="popup-connected-text">{account?.slice(0, 9)}...{account?.slice(account?.length - 9, account?.length)}</span>
            </h3>{" "}
          </div>
        </div>
      </div>
      <div className="popup-section-2">
        <div className="popup-section-21">
          <div id="popup-section-2-1">
            <h3>Experted BNB Tokens</h3>
            <h2>{dividend ? dividend : 0} BNB*</h2>
            <h5 id="The-value-text-popup">
              The value provided is estimated amount and is liable to change
            </h5>
          </div>
          <div id="popup-section-2-1">
            <h3>Claimable BNB Tokens</h3>
            <h2>{dividend ? dividend : 0} BNB</h2>
          </div>
        </div>

        <div id="claim-now-btn">
          <button onClick={claim} style={{ cursor: 'pointer'}}>CLAIM NOW</button>
        </div>
      </div>

      <div></div>
    </div>
  );
};

export default About;
